import env from '../../config/env'
import { fetcher } from '../../utils/helpers'

export const GetMetadataFetcher = async (url: string) => {
  return await fetcher({
    baseURL: env.metaUrl,
    url,
  })
}

export const GetStaticMetaFile = async () => {
  const res = await fetch('/meta.json')
  const json = await res.json()
  return json
}
